import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Badge, Nav, NavItem } from 'reactstrap';
import classNames from 'classnames';
import { riskAssessmentUrl } from 'Config';
import Loader from 'react-loader';
import AuthService from '../../services/AuthService'
import RestService from '../../services/REST/RestService';

import HttpClient from '../../services/REST/HttpClient';
import { Subscription } from 'rxjs';
import store from 'store';

const userTitle = {
  marginLeft: '4px',
  fontStyle: 'normal',
  paddingLeft: '10px',
  // fontFamily:'Open Sans',
  fontSize: '14px',
  textTransform: 'none'
}

class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.subscriptions = new Subscription();
    this.interval = 120;

    this.state = {
      alerting: null,
      notifications: null,
      isMenuClosed: false,
      menuItems: [],
      menuLoaded: true
    }
    this.riskFusionRedirect = this.riskFusionRedirect.bind(this);
    this.riskAssessmentUsage = this.riskAssessmentUsage.bind(this);
    this.sidebarToggleKeyup = this.sidebarToggleKeyup.bind(this);
    this.sidebarToggle = this.sidebarToggle.bind(this);
  }

  componentDidMount() {
    // Temporarily disabled
    // this.getNotifications();
    // this.getAlerting();
    // this.runBadgeInterval();
    window.addEventListener("storage", (function (e) {
      if (store.get('isMenuClosed') != this.state.isMenuClosed) this.setState({ isMenuClosed: store.get('isMenuClosed') });
    }).bind(this));
    this.getMenuItems();
  }

  componentWillUnmount() {
    this.subscriptions.unsubscribe();
  }

  getMenuItems() {
    this.setState(state => {
      state.menuLoaded = false;
      return state;
    });
    this.subscriptions.add(
      HttpClient.get('/user-access/').subscribe(resp => {
        this.setState(state => {
          state.menuItems = resp.data.menu_items;
          state.menuLoaded = true;
          return state;
        });
        AuthService.setUserRoles(resp.data.roles);
      }, e => {
        this.setState(state => {
          state.menuLoaded = true;
          return state;
        });
      })
    );
  }

  riskAssessmentUsage() {
    this.subscriptions.add(
      HttpClient.post('/usage/', { feature_code: "Risk Assessment" }).subscribe(() => {
        this.subscriptions.unsubscribe();
        window.location.href = window.location.origin + riskAssessmentUrl
      })
    );
  }

  getAlerting() {
    this.subscriptions.add(
      HttpClient.get('/inbox-count/').subscribe(resp => {
        this.setState({ alerting: (resp.data.inbox > 0 ? resp.data.inbox : null) });
      })
    );
  }

  getNotifications() {
    this.subscriptions.add(
      HttpClient.get('/notification-count/').subscribe(resp => {
        this.setState({ notifications: (resp.data.notifications > 0 ? resp.data.notifications : null) });
      })
    );
  }

  runBadgeInterval() {
    setInterval(() => this.getAlerting(), this.interval * 1000);
    setInterval(() => this.getNotifications(), this.interval * 1000);
  }

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';

  }

  // todo Sidebar nav secondLevel
  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  riskFusionRedirect() {
    RestService.riskFusion().then(resp => {
      if (resp.data.redirect) window.location.href = resp.data.redirect;
      else this.setState({ error: resp.data.error, loaded: true });
    })
      .catch(e => {
        this.setState({ loaded: true });
        this.props.history.push('/login');
      });
  }

  sidebarToggle(e) {
    const app = document.querySelector('body.app');
    const isMenuClosed = app.classList.contains('sidebar-hidden');
    store.set('isMenuClosed', !store.get('isMenuClosed'));
    const trg = e.target;

    if (!isMenuClosed) {
      if (!trg.classList.contains('sidebar-toggle')) return;
    }
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarToggleKeyup(e) {
    if (e.keyCode === 13) this.sidebarToggle(e);
  }

  render() {

    const props = this.props;
    const activeRoute = this.activeRoute;
    const handleClick = this.handleClick;
    const username = AuthService.getUsername();
    const isAdmin = AuthService.isAdmin()

    // badge addon to NavItem
    const badge = (badge) => {
      if (badge && badge.text) {
        const classes = classNames(badge.class);
        return (<Badge className={classes} color={badge.variant}>{badge.text}</Badge>)
      }
    };

    // simple wrapper for nav-title item
    const wrapper = item => { return (!item.wrapper ? item.name : (React.createElement(item.wrapper.element, item.wrapper.attributes, item.name))) };

    // nav list section title
    const title = (title, key) => {
      const classes = classNames("nav-title", title.class);
      return (<li key={key} className={classes}>{wrapper(title)} </li>);
    };

    // nav list divider
    const divider = (divider, key) => (<li key={key} className="divider"></li>);

    // nav item with nav link
    const navItem = (item, key) => {
      const classes = classNames("nav-link", item.class);

      if (item.name === 'My Queue') {
        item.badge = {
          text: this.state.alerting,
          variant: 'success'
        };
      }
      if (item.name === 'Notifications') {
        item.badge = {
          text: this.state.notifications,
          variant: 'success'
        }
      }

      if (item.access && !AuthService.checkAccess(item.access)) return null;

      return (
        <NavItem key={key}>
          {item.name === 'RiskFusion' &&
            <span className="nav-link" onClick={this.riskFusionRedirect}>
              {/* <i className="fa fa-angle-double-right"></i> */}
              RiskFusion
            </span>
          }

          {item.name === 'Risk Assessment' && AuthService.checkAccess('riskAssessment') &&
            <span className="nav-link" onClick={this.riskAssessmentUsage}>
              {/* <i className="fa fa-angle-double-right"></i> */}
              Risk Assessment
            </span>
          }

          {item.name !== 'RiskFusion' && item.name !== 'Risk Assessment' && item.name !== 'System Admin' && item.name !== 'Content Workbench' && item.name !== 'Classification Models' &&
            <NavLink to={item.url} className={classes} activeClassName="active">
              {/* <i className="fa fa-angle-double-right"></i> */}
              {item.name}{badge(item.badge)}
            </NavLink>
          }

          {(item.name === 'System Admin' || item.name === 'Content Workbench' || item.name === 'Classification Models') &&
            <a href={item.url} target="_blank" className={classes}>{item.name}</a>
            // <NavLink to={item.url} target="_blank" className={classes} activeClassName="active">
            //   {/* <i className="fa fa-angle-double-right"></i> */}
            //   {item.name}{badge(item.badge)}
            // </NavLink>
          }
        </NavItem>
      )
    };

    // nav dropdown
    const navDropdown = (item, key) => {
      return (
        <li key={key} className={activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick.bind(this)}><i className={item.icon}></i> {item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children)}
          </ul>
        </li>)
    };

    // nav link
    const navLink = (item, idx) =>
      item.title ? title(item, idx) :
        item.divider ? divider(item, idx) :
          item.children ? navDropdown(item, idx)
            : navItem(item, idx);

    // nav list
    const navList = (items) => {
      return items.map((item, index) => navLink(item, index));
    };

    // sidebar-nav root
    return (
      <div className="sidebar" tabIndex="0" onClick={this.sidebarToggle} onKeyUp={this.sidebarToggleKeyup}>
        <nav className="sidebar-nav">
          <Loader loaded={this.state.menuLoaded} color='#FFFFFF' top="30px" left="50%" scale="0.7">
            <Nav>
              {/* <li key='username' className="nav-title" style={userTitle}>
                  <span><i className="fa fa-user"></i>&nbsp;&nbsp;{username}</span>
                </li> */}
              {/* <li key='divider' className="divider"></li> */}
              {navList(this.state.menuItems)}
            </Nav>
          </Loader>
        </nav>
        <div className="sidebar-toggle" tabIndex="0">
          <i className={this.state.isMenuClosed ? 'fa fa-angle-right' : 'fa fa-angle-left'}></i>
        </div>
        {/* <i className="fa fa-long-arrow-left sidebar-toggle" onClick={this.sidebarToggle}></i> */}
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js